import { useTranslation } from "react-i18next";
import type { CardType } from "../domain/data/models/card-type";
import tarotBack from  './../../../assets/images/tarot_back.jpg'

export default function Card({card} : {card: CardType}) {
  const {t} = useTranslation()
  return(<>
      <div className="col-lg-3 col-md-4 col-sm-6 col-12">
        <div className="ast_tarot_box">
          <div className="content-single-card">
            <img src={tarotBack} alt="tarot" title="Tarot Card" />
            <div className="terot_content" style={{backgroundImage: `url(${card.image})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat'}}>
              <h3>{t('tarot_about_card')}</h3>
              <p>{t(`card.description.${card.title}`)}</p>
            </div>
            <h4>{t(`card.titles.${card.title}`)}</h4>
          </div>
        </div>
      </div>
    
  </>)
}